import { mapSelbstbeteiligung } from '@ps20-frontend/migrations';
import { Vertragsoptionen } from '@ps20-frontend/frontend-models';
import { StatePreV4, StateV4 } from './4_migrate_selbstbeteiligung.interface';

export const migrateSelbstbeteiligung = (
  previousState: StatePreV4,
  newVersion: number,
): StateV4 => {
  return {
    ...previousState,
    version: newVersion,
    vertragsoptionen: {
      ...previousState.vertragsoptionen,
      selbstbeteiligung: mapSelbstbeteiligung(previousState.vertragsoptionen.selbstbeteiligung),
    } as Vertragsoptionen,
  };
};
